import logo from './logo.svg';
import './App.css';
import Home from './components/Home';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Login  from './components/Login';
import Register  from './components/Register';
import Blog from './components/Blog';
import Product from './components/Product';
import Contact from './components/Contact';
import Pages from './components/Pages';
import Dashboard from './components/Dashboard';
import CompleteProfile from './components/CompleteProfile';
import PrivateRoute from './components/PrivateRoute';
import Profile from './components/Profile';
import ChangePassword from './components/ChangePassword';
import Subscription from './components/Subscription';
import Cart from './components/Cart';
import BlogDetail from './components/BlogDetail';
import BlogByCategory from './components/BlogsByCategory';
import BlogByTags from './components/BlogByTags';
import InvestHealthcare from './components/InvestHealthcare';
import HealthcarePlan from './components/HealthcarePlan';
import RiskAssestment from './components/RiskAssestment';
import GoalSettings from './components/GoalSettings';
import MutualFunds from './components/MutualFunds/index';
import MfDetail from './components/MutualFunds/mf-detail';
import ForgotPassword from './components/ForgotPassword';
import CANRegister from './components/CANRegister';
import Investment from './components/investment';
import InvestmentSip from './components/investment/sip';
import InvestmentSwitch from './components/investment/switch';
import InvestmentSwp from './components/investment/swp';
import InvestmentStp from './components/investment/stp';
import InvestmentRedeem from './components/investment/redeem';
import MfSipDetail from './components/MutualFunds/mf-sip-detail';
import EPayEezz from './components/ePayEezz';
import MfIndexDetail from './components/MutualFunds/mf-index-detail'
import ThankYou from './components/ThankYou';
import GoalDetail from './components/GoalSettings/goal-detail';
import BankDetails from './components/BankDetail';
import AllTransactions from './components/AllTransactions';
import MutualFundsErrorPage from './components/MutualFunds/mf-error-page';
import MfRedeemDetail from './components/MutualFunds/mf-redeem-detail';
import MfSwitchDetail from './components/MutualFunds/mf-switch-detail';
import InvestorConcent from './components/InvestorConcent'
import Holdings from './components/Holdings';
import AddMoreBank from './components/AddMoreBank';
import NomineeVerify from './components/NomineeVerify';
import RegisterIntro from './components/Register/registerintro';
import RegisterAsCustomer from './components/Register/registerascustomers';
import ResetPasswordLink from './components/ResetPasswordLink';
import TradingViewWidget from './components/TradingViewWidget';
function App() {
  return (
    <Router>
    <div className="App">
        <Switch> 
          <Route exact path='/' activeClassName="active" component={Home}/>
          <Route exact path='/login' component={Login}/>
          <Route exact path='/register' component={Register}/>
          <Route exact path='/registerintro' component={RegisterIntro}/>
          <Route exact path='/registerascustomer' component={RegisterAsCustomer}/>
          <Route exact path='/product-pricing' component={Product}/>
          <Route exact path='/blog' activeClassName="active"component={Blog }/>
          <Route exact path='/contact' activeClassName="active"component={Contact}/>
          <Route exact path='/resetpassword' activeClassName="active"component={ForgotPassword}/>
          <PrivateRoute exact path='/dashboard' activeClassName="active" component={Dashboard} />
          <PrivateRoute exact path='/risk-assestment' component={RiskAssestment} />
          <Route exact path='/blog-detail/:slug' component={BlogDetail} />
          <Route exact path='/blog-category/:slug' component={BlogByCategory} />
          <Route exact path='/blog-tags/:slug' component={BlogByTags} />
          <PrivateRoute exact path='/canregister/:gotostep?' component={CANRegister} />
          <PrivateRoute exact path='/healthcareplan' component={HealthcarePlan} />
          <PrivateRoute exact path='/goalsettings' component={GoalSettings} />
          <PrivateRoute exact path='/mutualfunds/:type?' component={MutualFunds} />
          <PrivateRoute exact path='/alltransactions' component={AllTransactions} />
          <PrivateRoute exact path='/mfdetail/:id' component={MfDetail} />
          <PrivateRoute exact path='/mfindexdetail/:id' component={MfIndexDetail} />
          <PrivateRoute exact path='/mfsipdetail/:goalid?' component={MfSipDetail} />
          <PrivateRoute exact path='/investment/:id?' component={Investment} />
          <PrivateRoute exact path='/sipinvestment/:id?' component={InvestmentSip} />
          <PrivateRoute exact path='/switchinvestment/:id?' component={InvestmentSwitch} />
          <PrivateRoute exact path='/swpinvestment/:id?' component={InvestmentSwp} />
          <PrivateRoute exact path='/stpinvestment/:id?' component={InvestmentStp} />
          <PrivateRoute exact path='/redeeminvestment/:id?' component={InvestmentRedeem} />
          <PrivateRoute exact path='/epayezzregistration' component={EPayEezz} />
          <PrivateRoute exact path='/thankyou/:id?' component={ThankYou} />
          <PrivateRoute exact path='/goal-detail/:id?' component={GoalDetail} />
          <PrivateRoute exact path='/investorconcent' component={InvestorConcent} />
          <PrivateRoute exact path='/invest-healthcare' component={InvestHealthcare} />
          <PrivateRoute exact path='/completeprofile' component={CompleteProfile} />
          <PrivateRoute exact path='/profile' component={Profile} />
          <PrivateRoute exact path='/changepassword' component={ChangePassword} />
          <PrivateRoute exact path='/subscription' component={Subscription} />
          <PrivateRoute exact path='/cart' component={Cart} />
          <PrivateRoute exact path='/bankdetails' component={BankDetails} />
          <PrivateRoute exact path='/mferror' component={MutualFundsErrorPage} />
          <PrivateRoute exact path='/mfredeem/:id' component={MfRedeemDetail} />
          <PrivateRoute exact path='/mfswitch/:id' component={MfSwitchDetail} />
          <PrivateRoute exact path='/addmorebank' component={AddMoreBank} />
          <PrivateRoute exact path='/holdings' component={Holdings} />
          <PrivateRoute exact path='/nomineeverify' component={NomineeVerify} />
          <Route exact path='/resetpasswordlink' component={ResetPasswordLink} />
          <Route exact path='/ta' component={TradingViewWidget} />
          <Route exact path='/:slug' activeClassName="active" component={Pages} />
          </Switch>
    </div>
    </Router>
  );
}

export default App;
